module.exports = __webpack_public_path__ + "static/img/home_banner01.76be11bc.jpg";